import { render, staticRenderFns } from "./TableNoHeader.vue?vue&type=template&id=47af1869&scoped=true&"
import script from "./TableNoHeader.vue?vue&type=script&lang=js&"
export * from "./TableNoHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableNoHeader.vue?vue&type=style&index=0&id=47af1869&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af1869",
  null
  
)

export default component.exports